//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'vant'
export default {
  name: 'articleDetail',
  data () {
    return {
      maxH: 300,
      top: 0,
      detail: {
        typeName: '',
        createTime: '',
        answer: ''
      }
    }
  },
  watch: {
    $route () {
      this.getDetail()
    }
  },
  mounted () {
    let scoreTopY = document.getElementById('scoreTop').getBoundingClientRect().bottom
    let footerY = document.getElementById('footer').getBoundingClientRect().top
    // 22 div 上下padding + 边框 15 div距离footer间距 20 statusbar高度
    // this.maxH = footerY - scoreTopY - 22 - 15 - 30
    console.log(document.documentElement.clientHeight, scoreTopY, footerY)
    this.getDetail()
  },
  activted () {
    this.getDetail()
  },
  methods: {
    onClickLeft () {
      this.$router.goBack()
    },
    copy () {
      if (this.$global.isApp) {
        var clipBoard = api.require('clipBoard')
        clipBoard.set(
          {
            value: this.detail.answer,
          },
          function (ret, err) {
            console.log('复制', ret, err)
            if (ret.status) {
              Toast({
                message: '复制成功',
                duration: 1000,
              })
            } else {
              Toast({
                message: '复制失败',
                duration: 1000,
              })
            }
          }
        )
      } else {
        var input = document.createElement('input');
        input.setAttribute('id', 'copyInput');
        input.setAttribute('value', this.detail.answer);
        document.body.appendChild(input);
        document.getElementById('copyInput').select();
        document.execCommand('copy')
        Toast.success("已复制")
        document.body.removeChild(input)
      }
    },
    //时间格式化
    transferTime (timestamp) {
      return new Date(parseFloat(timestamp)).toLocaleString()
    },
    getDetail () {
      this.detail = JSON.parse(localStorage.getItem('detail'))
      console.log(this.detail)
    }
  },
  created () {
    if (this.$global.isApp) {
      this.top = api.safeArea.top
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Create/articleDetail.vue